import { produce } from "../../../../immer/index.js";
import { regenerateErrorsByField } from "./regenerateErrorsByField.js";
const emptyErrorArray = [];
function createErrorsApi(store, errorsByField, getLogger, getSubscribersApi, refreshFormStatus) {
  const { notifyFieldSubscriber, notifyFormSubscribers } = getSubscribersApi();
  regenerateErrorsByField(store, errorsByField);
  const errorsApi = {
    getErrors: () => {
      return store.errors;
    },
    // FIXME: better types
    // @ts-expect-error: TS is unable to reconcile ERROR[] with FormError<FIELD_NAME>[]
    getFieldErrors: (fieldName) => {
      const field = store.fields[fieldName];
      if (!field) {
        return emptyErrorArray;
      }
      const fieldErrors = errorsByField.get(fieldName) ?? [];
      errorsByField.set(fieldName, fieldErrors);
      return fieldErrors;
    },
    clearError: (...ids) => {
      const log = getLogger();
      log("clearErrorById", ids?.length > 0 ? ids : "all errors");
      const affectedFields = /* @__PURE__ */ new Set();
      function shouldClearError(id) {
        return ids.length === 0 ? true : ids.includes(id);
      }
      store.errors = produce(store.errors, (draft) => {
        for (const errorId of Object.keys(draft)) {
          const fieldName = draft[errorId].field;
          if (shouldClearError(errorId)) {
            delete draft[errorId];
            affectedFields.add(fieldName);
            let fieldErrors = errorsByField.get(fieldName) ?? [];
            fieldErrors = fieldErrors.filter((error) => error.id !== errorId);
            errorsByField.set(fieldName, fieldErrors);
          }
        }
      });
      store.fields = produce(store.fields, (draft) => {
        for (const [fieldName, value] of Object.entries(draft)) {
          if (affectedFields.has(fieldName)) {
            const field = value;
            field.status = "indeterminate";
            notifyFieldSubscriber(fieldName);
          }
        }
      });
      refreshFormStatus();
      notifyFormSubscribers();
    }
  };
  return errorsApi;
}
export {
  createErrorsApi
};
//# sourceMappingURL=createErrorsApi.js.map
